import styles from './index.module.less';
import OurModal from '@/components/Modal/index';
import { useTranslation } from 'react-i18next';
import { useConfigProvider } from '@/context/ConfigProvider';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
const Index = ({
  username,
  isModalOpen,
  handleCancel,
}: {
  username?: string;
  isModalOpen: boolean;
  handleCancel: () => void;
}) => {
  const { t } = useTranslation();
  const { isMobile } = useConfigProvider();
  const handleFollow = () => {
    ga_logEvent(EventName.Report_detail_Follow_us);
    if (isMobile) {
      window.open(`twitter://user?screen_name=Erasaprotect`, '_blank');
    } else {
      window.open(`https://x.com/intent/follow?screen_name=Erasaprotect`, '_blank');
    }
  };
  return (
    <OurModal isModalOpen={isModalOpen} handleCancel={handleCancel} width={400}>
      <div className={styles.container}>
        <div>{t('Monitoring Activated')}</div>
        <div>
          {t("Great news! We've successfully added your account")} <span>{username || ''}</span>{' '}
          {t(
            'to our monitoring system. To stay in the loop with the latest reports and updates, make sure to follow our official X (formerly Twitter) account.',
          )}
        </div>
        <div>{t('Connect with us on X')}</div>
        <div>
          <div>
            <img src="/images/erasa/platforms/space.png" alt="X" />
            <span>Erasa</span>
          </div>
          <div onClick={handleFollow}>{t('Follow')}</div>
        </div>
        <div onClick={handleFollow}>{t('Follow on X for Updates')}</div>
        <div>{t("By following, you'll receive real-time alerts and comprehensive reports directly through X.")}</div>
      </div>
    </OurModal>
  );
};

export default Index;
